<template>
  <v-container fluid class="pa-0">
    <!-- <view-header v-if="table_only === undefined || table_only === false"
     :title="title" :description="getDescription()"
     :icon="icon"/> -->
    <v-container fluid class="pa-5">
      <generic-data-table 
        :items="entities[entity_name]" 
        :loading="loading" 
        :headers="headers" 
        :search="search"
        :entity_name="entity_name"
        :localizable_fields="localizable_fields"
        :user_id="user !== undefined ? current_entity[entity_name].id : undefined"
        :driver_id="driver !== undefined? current_entity[entity_name].id : undefined"
        :paginated="paginated"
        :show_clear="show_clear"
        :show_excel="show_excel"
        :show_print="show_print"
        :table_only="table_only"
        :showCardView="showCardView"
        :title="title"
        :hideAddButton="hideAddButton"
        :allowEdit="allowEdit"
        @add="saveEntity(null)"
        @rowClick="row => saveEntity(row)"
        @editItemHidden="editItemHidden()"
      >
      </generic-data-table>
    </v-container>

      <!-- <waybill-view-new
      :items="entities[entity_name]" 
        :loading="loading" 
        :headers="headers" 
        :search="search"
        :entity_name="entity_name"
        :localizable_fields="localizable_fields"
        :user_id="user !== undefined ? current_entity[entity_name].id : undefined"
        :driver_id="driver !== undefined? current_entity[entity_name].id : undefined"
        :paginated="paginated"
        :show_clear="show_clear"
        :show_excel="show_excel"
        :show_print="show_print"
        :table_only="table_only"
        :title="title"
        :hideAddButton="hideAddButton"
        :allowEdit="allowEdit"
        @add="saveEntity(null)"
        @rowClick="row => saveEntity(row)"
        @editItemHidden="editItemHidden()"
      >

      </waybill-view-new> -->

    <edit-item
      v-if="showEditItem && table_only===undefined" 
      v-model="showEditItem" 
      :entityName="entity_name" 
      :coordinate="coordinate"
      :entity_fields="headers"
      :localizable_fields="localizable_fields"
      :user_id="user !== undefined ? current_entity[entity_name].id : undefined"
      :driver_id="driver !== undefined? current_entity[entity_name].id : undefined"
      :data="current_entity[entity_name]"
      :fullscreen="fullscreen"
      @entity_posted="entity_posted"
      :shareable="shareable"
    >
    </edit-item>

    <waybill-edit-item
      v-if="showWaybillEdit && table_only === undefined"
      v-model="showWaybillEdit" 
      :entityName="entity_name"
        :coordinate="coordinate"
        :entity_fields="headers"
        :localizable_fields="localizable_fields"
        :user_id="user !== undefined ? current_entity[entity_name].id : undefined"
        :driver_id="driver !== undefined ? current_entity[entity_name].id : undefined"
        :data="current_entity[entity_name]"
        :fullscreen="fullscreen"
        @entity_posted="entity_posted"
        :shareable="shareable"
      >

    </waybill-edit-item>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EditItem from '@/components/EditItem';
import WaybillEditItem from '@/components/WaybillEditItem';
import GenericDataTable from '@/components/GenericDataTable';
import WaybillViewNew from '@/components/WaybillViewNew'

export default {
  name:'generic-view',
  props:['title','entity_name','showCardView','headers','localizable_fields','coordinate','user','driver','fullscreen','isActive','shareable','paginated','table_only','hubMethod','icon','hideAddButton','allowEdit','show_clear','show_excel','show_print'],
  data() {
    return  {
      search: '',
      showEditItem: false,
      showWaybillEdit: false,
      renderEditItem:true,
      page:1,
      perPage:10,
      search:""
    }
  },
  computed: {
    ...mapState('entities',['current_entity','entities','loading','selected_search_entity','pageCount'])
  },
  components: {
    EditItem, GenericDataTable, WaybillEditItem, WaybillViewNew
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity','getPendingEntities','getPaginatedEntities','clearAllEntities']),
    saveEntity(entity) {
      if (this.entity_name == 'wayBill') {
        this.showWaybillEdit = true;
      } else
        this.showEditItem = true;

        if(entity !== null) this.current_entity[this.entity_name] = entity
        else {
          //reset the search
          this.selected_search_entity['user'] = {}
          this.selected_search_entity['driver'] = {}
        }
    },
    getDescription(){
        return `Manage the ${this.title} from this CMS portal.`
    },
    editItemHidden() {
      //delay render switch to keep animations
      setTimeout(() => {
        this.renderEditItem = false;
      }, 500);
      setTimeout(() => {
        this.renderEditItem = true;
      }, 1000);
    },
    entity_posted() {
      this.showEditItem = false;
      this.$emit('entity_posted')
    },
    reloadData(){
      if(this.paginated === undefined || this.paginated === false)
        this.getEntities(this.entity_name)
      else {
        var paginatedPayload =  {
          name:this.entity_name,
          page:this.page,
          perPage:this.perPage,
          search:this.search
        }
        this.getPaginatedEntities(paginatedPayload)
      }
    }
  },
  mounted() {
      this.reloadData();
      if(this.hubMethod !== undefined) {
        this.$driverHub.$on(this.hubMethod, this.reloadData)
      }
  }
}
</script>